import * as Vehicle from '@/services/rest-api/lib/fleet-task/vehicle'

export const vehicleFieldsMixin = {
  computed: {
    vehicleFields() {
      return [
        {
          key: 'transaction_date',
          name: 'transaction_date',
          label: this.$t('costManagement.fields.transactionDate'),
          valueType: 'YYYY-MM-DD',
          type: 'date-picker',
          validation: 'required',
          format: 'DD MMMM YYYY',
        },
        {
          key: 'funds_account_source',
          name: 'funds_account_source',
          label: this.$t('costManagement.form.sourceOfFundsAccount'),
          placeholder: `${this.$t('global.form.enter')} ${this.$t(
            'costManagement.form.sourceOfFundsAccount'
          )}`,
          type: 'text',
        },
        {
          name: 'vehicle_id',
          showKey: 'vehicle',
          type: 'value-help-v2',
          label: this.$t('costManagement.form.licensePlate'),
          placeholder: `${this.$t('global.form.select')} ${this.$t(
            'costManagement.form.licensePlate'
          )}`,
          validation: 'required',
          valueType: 'id',
          trackBy: 'id',
          displayedBy: 'license_plate',
          listGetter: (queryParam) => {
            queryParam.filters = queryParam.filters ? queryParam.filters : []
            queryParam.filters.push('parent_only = true')

            return Vehicle.get(queryParam)
          },
          getInitialObject: (data) => data?.vehicle,

          tableFields: [
            {
              label: this.$t('costManagement.form.licensePlate'),
              key: 'license_plate',
              isSortable: true,
            },
            {
              label: this.$t('costManagement.form.driver'),
              key: 'driver.name',
              isSortable: true,
            },
          ],
          hasStoreAction: false,
        },
      ]
    },
  },
}
